// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PaymentPageSecureBlock-module-secureImg-yk9y1{display:flex;justify-content:center;color:#373a36;font-size:16px;font-weight:var(--weight-light);letter-spacing:0;line-height:23px}.PaymentPageSecureBlock-module-secureImg-yk9y1 span{-webkit-padding-start:5px;padding-inline-start:5px}.PaymentPageSecureBlock-module-secureTxt--Wu5\\+{padding:24px;color:#5b615e;font-size:13px;font-weight:var(--weight-light);letter-spacing:0;line-height:19px;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"secureImg": "PaymentPageSecureBlock-module-secureImg-yk9y1",
	"secureTxt": "PaymentPageSecureBlock-module-secureTxt--Wu5+"
};
export default ___CSS_LOADER_EXPORT___;
